/**
 * サンプル関連の定数定義
 *
 * 使用記録アクション・ステータス等はバックエンドが日本語リテラルで扱うため値はそのまま。
 * サンプル種別（sampleType）は DB に日本語で保存されるが、フォーム/フィルターは英語コードを value にし、
 * `utils/sampleTypeLabels.ts` で API 送受信時に変換する。
 */

// 使用記録のアクション値（バックエンドで使用される値）
export const USAGE_ACTION = {
  USE: '使用',
  DISPOSE: '廃棄',
  MOVE: '移動',
  OTHER: 'その他',
  CREATED: 'サンプル新規登録',
} as const;

/** 新規使用記録フォームの数量既定（0 は確認のみ用途で明示入力） */
export const DEFAULT_USAGE_RECORD_QUANTITY = 1;

// サンプルのステータス値（バックエンドで使用される値）
export const SAMPLE_STATUS = {
  AVAILABLE: '利用可能',
  OUT_OF_STOCK: '在庫なし',
  DISPOSED: '廃棄済み',
} as const;

/** BSL / ABSL 選択肢（フォーム・フィルター共通） */
export const BSL_LEVELS = [
  'BSL-1',
  'BSL-2',
  'BSL-3',
  'BSL-4',
  'ABSL-1',
  'ABSL-2',
  'ABSL-3',
  'ABSL-4',
] as const;

// 使用記録のpurpose値（バックエンドで使用される値）
export const USAGE_PURPOSE = {
  CREATED: 'サンプル新規登録',
} as const;

// アクション値の配列（Zodスキーマで使用）
export const USAGE_ACTION_VALUES = [
  USAGE_ACTION.USE,
  USAGE_ACTION.DISPOSE,
  USAGE_ACTION.MOVE,
  USAGE_ACTION.OTHER,
] as const;

// アクション値が作成レコードかどうかを判定
export const isCreationAction = (action: string | undefined): boolean => {
  return action === USAGE_ACTION.CREATED;
};

// purpose値が作成レコードかどうかを判定
export const isCreationPurpose = (purpose: string | undefined | null): boolean => {
  if (!purpose) return false;
  return (
    purpose === USAGE_PURPOSE.CREATED ||
    purpose.includes(USAGE_PURPOSE.CREATED) ||
    purpose.includes('初期数量')
  );
};

// 使用記録が作成レコードかどうかを判定（actionまたはpurposeから判定）
export const isCreationRecord = (
  record: { action?: string; purpose?: string | null } | undefined
): boolean => {
  if (!record) return false;
  return isCreationAction(record.action) || isCreationPurpose(record.purpose);
};

